import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-lg font-bold">
                <i className="ri-book-read-line"></i>
              </span>
              <span className="text-xl font-bold text-background-50 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                爱漫画
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              汇聚无删减韩国漫画，下拉式免费韩漫大全在线阅读便捷，优质韩漫作品持续上新。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">快速导航</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">首页</Link>
              </li>
              <li>
                <Link to="/category" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">漫画分类</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">热门分类</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category?cat=romance" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">恋爱漫画</Link>
              </li>
              <li>
                <Link to="/category?cat=fantasy" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">奇幻漫画</Link>
              </li>
              <li>
                <Link to="/category?cat=action" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">动作漫画</Link>
              </li>
              <li>
                <Link to="/category?cat=suspense" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">悬疑漫画</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">联系我们</h3>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@aimanhua.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-customer-service-line text-primary-400"></i>
                <span>客服QQ：1234567890</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 爱漫画 - 韩国漫画无删减漫画下拉式免费韩漫大全 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}